import {
	createRouter,
	createWebHashHistory
} from 'vue-router'

export const routes = [{
	path: "/login",
	name: 'login',
	meta: {
		notoken: true
	},
	component: () => import('@/views/login/login.vue')
},
{
	path: "/password",
	name: 'password',
	meta: {
		notoken: true
	},
	notoken: true,
	component: () => import('@/views/login/password.vue')
},
{
	path: "/",
	component: () => import('@/components/navbar.vue'),
	children: [
		{
			path: '/databoard',
			name: 'databoard',
			component: () => import('@/views/databoard.vue'),
			meta: {
				titL: ['数据台'],
				tab: '/databoard',
			},
		},
	]
},
{
	path: "/",
	component: () => import('@/components/navbar.vue'),
	children: [
		{
			path: '/service/list',
			name: 'service/list',
			component: () => import('@/views/service/list.vue'),
			meta: {
				titL: ['服务列表'],
				tab: '/service/list',
				rejectType: 1,
			},
		},
		{
			path: '/service/add',
			name: 'service/add',
			component: () => import('@/views/service/add.vue'),
			meta: {
				titL: ['添加服务'],
				tab: '/service/list',
				rejectType: 1,
			},
		},
		// {
		// 	path: '/service/type',
		// 	name: 'service/type',
		// 	component: () => import('@/views/service/type.vue'),
		// 	meta: {
		// 		titL: ['分类管理'],
		// 		tab: '/service/type',
		// 		rejectType: 1,
		// 	},
		// },
		{
			path: '/service/evaluate',
			name: 'service/evaluate',
			component: () => import('@/views/service/evaluate.vue'),
			meta: {
				titL: ['服务评价'],
				tab: '/service/evaluate',
				rejectType: 1,
			},
		},
		{
			path: "/service/storeorder",
			name: 'service/storeorder',
			component: () => import('@/views/service/storeorder.vue'),
			meta: {
				titL: ['预约到店单'],
				tab: '/service/storeorder',
				rejectType: 1,
			},
		},
		{
			path: "/service/orderdetail/:orderId",
			name: 'service/orderdetail',
			component: () => import('@/views/service/orderdetail.vue'),
			meta: {
				titL: ['预约到店单'],
				tab: '/service/storeorder',
				rejectType: 1,
			},
		},
		{
			path: "/service/serviceorder",
			name: 'service/serviceorder',
			component: () => import('@/views/service/serviceorder.vue'),
			meta: {
				titL: ['预约到店单'],
				tab: '/service/serviceorder',
				rejectType: 1,
			},
		},
		{
			path: "/service/refundorder",
			name: 'service/refundorder',
			component: () => import('@/views/service/refundorder.vue'),
			meta: {
				titL: ['售后服务订单'],
				tab: '/service/refundorder',
				rejectType: 1,
			},
		},
		{
			path: "/service/refund/:returnId",
			name: 'service/refund',
			component: () => import('@/views/service/refundId.vue'),
			meta: {
				titL: ['售后服务订单'],
				tab: '/service/refundorder',
				rejectType: 1,
			},
		},
		{
			path: "/service/report",
			name: 'service/report',
			component: () => import('@/views/service/report.vue'),
			meta: {
				titL: ['举报列表'],
				tab: '/service/report',
				rejectType: 1,
			},
		},
	]
},
{
	path: "/",
	component: () => import('@/components/navbar.vue'),
	children: [
		{
			path: "/store/item",
			name: 'store/item',
			component: () => import('@/views/store/item.vue'),
			meta: {
				titL: ['商品管理'],
				tab: '/store/item',
				rejectType: 2,
			},
		},
		{
			path: "/store/itemadd",
			name: 'store/itemadd',
			component: () => import('@/views/store/itemadd.vue'),
			meta: {
				titL: ['发布商品'],
				tab: '/store/item',
				rejectType: 2,
			},
		},
		{
			path: "/store/order",
			name: 'store/order',
			component: () => import('@/views/store/order.vue'),
			meta: {
				titL: ['订单管理'],
				tab: '/store/order',
				rejectType: 2,
			},
		},
		{
			path: "/store/refund",
			name: 'store/refund',
			component: () => import('@/views/store/refund.vue'),
			meta: {
				titL: ['退款订单'],
				tab: '/store/refund',
				rejectType: 2,
			},
		},
		{
			path: "/store/address",
			name: 'store/address',
			component: () => import('@/views/store/address.vue'),
			meta: {
				titL: ['店铺地址'],
				tab: '/store/address',
				rejectType: 2,
			},
		},
		{
			path: "/store/evaluate",
			name: 'store/evaluate',
			component: () => import('@/views/store/evaluate.vue'),
			meta: {
				titL: ['订单评价'],
				tab: '/store/evaluate',
				rejectType: 2,
			},
		},
		{
			path: "/store/orderdetail",
			name: 'store/orderdetail',
			component: () => import('@/views/store/orderdetail.vue'),
			meta: {
				titL: ['订单详情'],
				tab: '/store/order',
				rejectType: 2,
			},
		},
		{
			path: "/store/refund/:id",
			name: 'store/refund/Id',
			component: () => import('@/views/store/refunddetail.vue'),
			meta: {
				titL: ['退款详情'],
				tab: '/store/refund',
				rejectType: 2,
			},
		},
		// {
		// 	path: "/store/type",
		// 	name: 'store/type',
		// 	component: () => import('@/views/store/type.vue'),
		// 	meta: {
		// 		titL: ['分类管理'],
		// 		tab: '/store/type',
		// 		rejectType: 2,
		// 	},
		// },
		{
			path: "/store/freight",
			name: 'store/freight',
			component: () => import('@/views/store/freight.vue'),
			meta: {
				titL: ['运费模版管理'],
				tab: '/store/freight',
				rejectType: 2,
			},
		},

		/** ----------------------------- */
		{
			path: "/store/profile",
			name: 'store/profile',
			component: () => import('@/views/store/profile.vue'),
			meta: {
				titL: ['门店基本信息'],
				tab: '/store/profile',
			},
		},
		{
			path: "/store/album",
			name: 'store/album',
			component: () => import('@/views/store/album.vue'),
			meta: {
				titL: ['环境相册'],
				tab: '/store/album',
			},
		},
	]
},
{
	path: "/",
	title: '健康师管理',
	component: () => import('@/components/navbar.vue'),
	children: [
		{
			path: "/health/employeelist",
			name: 'health/employeelist',
			component: () => import('@/views/health/employeelist.vue'),
			meta: {
				titL: ['健康师列表'],
				tab: '/health/employeelist',
				rejectType: 1,
			},
		},
		{
			path: "/health/employeeadd",
			name: 'health/employeeadd',
			component: () => import('@/views/health/employeeadd.vue'),
			meta: {
				titL: ['添加健康师'],
				tab: '/health/employeelist',
				rejectType: 1,
			},
		},
		{
			path: "/health/employee/:id",
			name: 'health/employee',
			component: () => import('@/views/health/employee.vue'),
			meta: {
				titL: ['健康师详情'],
				tab: '/health/employeelist',
				rejectType: 1,
			},
		},
	]
},
{
	path: "/",
	title: '消息中心',
	component: () => import('@/components/navbar.vue'),
	children: [
		{
			path: "/message/index",
			name: 'message/index',
			component: () => import('@/views/message/index.vue'),
			meta: {
				titL: ['消息中心'],
				tab: '/message/index',
				keepAlive: true
			},
		},
		{
			path: "/message/list",
			name: 'message/list',
			component: () => import('@/views/message/list.vue'),
			meta: {
				titL: ['消息中心'],
				tab: '/message/index',
			},
		},
	]
},
{
	path: "/",
	title: '收支明细',
	component: () => import('@/components/navbar.vue'),
	children: [
		{
			path: "/finance/bill",
			name: 'finance/bill',
			component: () => import('@/views/finance/bill.vue'),
			meta: {
				titL: ['财务明细'],
				tab: '/finance/bill',
			},
		},
		{
			path: "/finance/billId",
			name: 'finance/billId',
			component: () => import('@/views/finance/billId.vue'),
			meta: {
				titL: ['明细详情'],
				tab: '/finance/bill',
			},
		},
		{
			path: "/finance/bank",
			name: 'finance/bank',
			component: () => import('@/views/finance/bank.vue'),
			meta: {
				titL: ['对公账户管理'],
				tab: '/finance/bank',
			},
		},
	]
},
{
	path: "/",
	title: '系统管理',
	component: () => import('@/components/navbar.vue'),
	children: [
		{
			path: "/system/account",
			name: 'system/account',
			component: () => import('@/views/system/account.vue'),
			meta: {
				titL: ['账号信息'],
				tab: '/system/account',
			},
		},
		// {
		// 	path: "/system/bind",
		// 	name: 'system/bind',
		// 	component: () => import('@/views/system/bind.vue'),
		// 	meta: {
		// 		titL: ['手机换绑'],
		// 		tab: '/system/account',
		// 	},
		// },
		{
			path: "/system/password",
			name: 'system/password',
			component: () => import('@/views/system/password.vue'),
			meta: {
				titL: ['修改密码'],
				tab: '/system/account',
			},
		},
		{
			path: "/system/log",
			name: 'system/log',
			component: () => import('@/views/system/log.vue'),
			meta: {
				titL: ['操作日志'],
				tab: '/system/log',
			},
		},
		{
			path: "/system/shopdata",
			name: 'system/shopdata',
			component: () => import('@/views/system/shopdata.vue'),
			meta: {
				titL: ['接单周期设置'],
				tab: '/system/shopdata',
			},
		}
	]
},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

export default router